import { draftResolutionOf } from '../../../contracts/approval-kinds';
import type { ToolUseItem } from '../../../contracts/harness.types';

import { SUPERSEDED_APPROVAL_REASON } from '../lib/steerPendingApprovals';

/**
 * The clinician's own note on a denied approval, read from the run snapshot because
 * the backend writes no user turn for it. Skips the superseded marker and draft resolutions.
 */
export const deniedApprovalUserNote = (item: ToolUseItem): string | null => {
  const approval = item.approval;
  if (approval?.status !== 'denied') return null;
  const reason = approval.reason?.trim();
  if (
    !reason ||
    reason === SUPERSEDED_APPROVAL_REASON ||
    draftResolutionOf(approval) !== null
  ) {
    return null;
  }
  return reason;
};
